import React from 'react';
import { Link, Body } from '@edreamsodigeo/prisma-design-system';
import PropTypes from 'prop-types';
import { useFlowComponent } from '@/hooks/useFlowComponent';
import { useSimpleModal } from '@/hooks/useSimpleModal';
import { useToggleHandler } from '@/hooks/useToggleHandler';
import {
  MoreInfoDrawerBanner,
  MoreInfoModalBanner,
} from '@/components/MoreInfoBanner';
import { useTranslation } from '@edreamsodigeo/frontend-core';
import { ACTIONS, usePFTracking } from '@/hooks/tracking';
import { useIsMounted } from '@/hooks/useIsMounted';

export const MoreInfoLink = ({
  days = 0,
  cap = {},
  deposit = {},
  type = 'base',
  tAlign = 'center',
}) => {
  const MoreInfoComponent = useFlowComponent(
    MoreInfoLinkDrawer,
    MoreInfoLinkModal
  );

  return (
    <MoreInfoComponent
      days={days}
      cap={cap}
      deposit={deposit}
      type={type}
      tAlign={tAlign}
    />
  );
};

const MoreInfoLinkDrawer = ({ days, cap, deposit, type }) => {
  const [openDrawer, toggleDrawer] = useToggleHandler(false);

  return (
    <>
      <MoreInfoLinkItem opener={toggleDrawer} type={type} />
      <MoreInfoDrawerBanner
        days={days}
        cap={cap}
        deposit={deposit}
        closeContent={toggleDrawer}
        openDrawer={openDrawer}
      />
    </>
  );
};

const MoreInfoLinkModal = ({ days, cap, deposit, type, tAlign }) => {
  const { openModal, closeModal, modalProps } = useSimpleModal(false);
  const isMounted = useIsMounted();
  return (
    <>
      <MoreInfoLinkItem opener={openModal} type={type} tAlign={tAlign} />
      {isMounted && (
        <MoreInfoModalBanner
          days={days}
          cap={cap}
          deposit={deposit}
          closeContent={closeModal}
          modalProps={modalProps}
        />
      )}
    </>
  );
};

const MoreInfoLinkItem = ({ opener, type, tAlign }) => {
  const { t } = useTranslation();
  const { track } = usePFTracking();

  const openerHandler = () => {
    track(ACTIONS.LEARN_MORE.CLICK.OPEN);
    track(ACTIONS.LEARN_MORE.ONLOAD);
    opener();
  };

  return (
    <Body type={type} textAlign={tAlign}>
      <Link
        href={'#'}
        onClick={openerHandler}
        target={'_self'}
        type={'dotted'}
        aria-label={'moreInfoLink'}
        size={type}
      >
        {t('pricefreeze.moreinfo.link')}
      </Link>
    </Body>
  );
};

MoreInfoLink.propTypes = {
  cap: PropTypes.shape({
    amount: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
  }).isRequired,
  deposit: PropTypes.shape({
    amount: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
  }).isRequired,
  days: PropTypes.number.isRequired,
};

export default MoreInfoLink;
